var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-card",class:{ 'pa-2': !_vm.flat }},[_c('v-card',{class:{
      'd-flex align-center': true,
      'cursor-pointer clickable': _vm.clickable,
      'is-large': _vm.large,
      'is-small': !_vm.large
    },attrs:{"flat":_vm.flat,"ripple":_vm.clickable},nativeOn:{"click":function($event){return _vm.cardClicked.apply(null, arguments)}}},[_c('customer-avatar',{staticClass:"px-3",attrs:{"customer":_vm.customer,"large":_vm.large}}),_c('div',{staticClass:"customer-card-content d-flex flex-column"},[_c('v-card-title',{staticClass:"pl-0",domProps:{"textContent":_vm._s(_vm.customer.full_name)}}),_c('v-card-subtitle',{staticClass:"pl-0",domProps:{"textContent":_vm._s(_vm.customer.shortAddress)}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }